import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["active", "className", "disableDropdown", "dropdownBreakpoint", "fullWidth", "menuPortalTarget", "options", "size", "tabClassname", "type", "variant", "onChange"];
import React, { forwardRef } from 'react';
import clsx from 'clsx';
import Tab from './Tab';
import Select from './../Select';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var styles = {
  "tabs": "pbui-5jyCd",
  "tabs--dropdown__breakpoint--sm": "pbui-WyR8x",
  "tabs--dropdown__breakpoint--md": "pbui-FFnCB",
  "tabs--disabled-dropdown": "pbui-V1HF3",
  "tabs--type-horizontal": "pbui-Mdlyu",
  "tabs--type-vertical": "pbui-BtGJo",
  "tabs--white-border-vertical": "pbui-XHX0g",
  "tabs--full-width": "pbui--z7UU",
  "tabs--underline": "pbui-b8LgK",
  "tabs--white-border": "pbui-0bhV7",
  "select--dropdown__breakpoint--sm": "pbui-AehUi",
  "select--dropdown__breakpoint--md": "pbui-hS4Xx",
  "tab--full-width": "pbui-vIMvy",
  "tab--vertical": "pbui-AbIvF",
  "button--primary": "pbui-KAkQ3",
  "button--primary-active": "pbui-coFz1",
  "button--gray": "pbui-WlXWP",
  "button--gray-active": "pbui-xUT-8",
  "button--white-border": "pbui-AOuIQ",
  "button--white-border-active": "pbui-hZL2K",
  "button--underline": "pbui-IQpA9",
  "button--underline-active": "pbui-XAXle",
  "button--underline-filled": "pbui-Mn-WI",
  "button--underline-filled-active": "pbui-0Ygvz"
};
var Tabs = /*#__PURE__*/forwardRef(function Tabs(props, ref) {
  var active = props.active,
    className = props.className,
    _props$disableDropdow = props.disableDropdown,
    disableDropdown = _props$disableDropdow === void 0 ? false : _props$disableDropdow,
    _props$dropdownBreakp = props.dropdownBreakpoint,
    dropdownBreakpoint = _props$dropdownBreakp === void 0 ? 'sm' : _props$dropdownBreakp,
    fullWidth = props.fullWidth,
    menuPortalTarget = props.menuPortalTarget,
    options = props.options,
    _props$size = props.size,
    size = _props$size === void 0 ? 'md' : _props$size,
    tabClassname = props.tabClassname,
    _props$type = props.type,
    type = _props$type === void 0 ? 'horizontal' : _props$type,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'primary' : _props$variant,
    onChange = props.onChange,
    rest = _objectWithoutProperties(props, _excluded);
  var tabsClasses = clsx(styles.tabs, className, fullWidth && styles['tabs--full-width'], disableDropdown && styles['tabs--disabled-dropdown'], {
    'horizontal': [styles['tabs--type-horizontal'], (variant === 'underline' || variant === 'underline-filled') && styles['tabs--underline']],
    'vertical': [styles['tabs--type-vertical'], variant === 'white-border' && styles['tabs--white-border-vertical']]
  }[type], {
    'sm': styles['tabs--dropdown__breakpoint--sm'],
    'md': styles['tabs--dropdown__breakpoint--md']
  }[dropdownBreakpoint], variant === 'white-border' && styles['tabs--white-border']);
  var selectClasses = clsx(styles.select, className, {
    'sm': styles['select--dropdown__breakpoint--sm'],
    'md': styles['select--dropdown__breakpoint--md']
  }[dropdownBreakpoint]);
  var tabClasses = clsx(tabClassname, fullWidth && styles['tab--full-width'], type === 'vertical' && styles['tab--vertical']);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", _extends({
      className: tabsClasses,
      ref: ref
    }, rest, {
      children: options.map(function (option) {
        return /*#__PURE__*/_jsx(Tab, {
          active: active === option.value,
          className: tabClasses,
          icon: option.icon,
          iconPosition: option.iconPosition,
          onClick: onChange,
          size: size,
          value: option.value,
          variant: variant,
          children: option.label
        }, option.value);
      })
    })), !disableDropdown && /*#__PURE__*/_jsx(Select, {
      className: selectClasses,
      menuPortalTarget: menuPortalTarget,
      onChange: onChange,
      options: options.map(function (option) {
        return {
          value: option.value,
          label: option.icon && option.iconPosition ? option.iconPosition === 'prefix' ? /*#__PURE__*/_jsxs("span", {
            children: [option.icon, " ", option.label]
          }) : /*#__PURE__*/_jsxs("span", {
            children: [option.label, " ", option.icon]
          }) : /*#__PURE__*/_jsx("span", {
            children: option.label
          })
        };
      })
    })]
  });
});
export default Tabs;